import type { AnimationTrack } from "../../../shared/api-contract";

interface Props {
  track: AnimationTrack;
  title: string;
  duration: number;
  selected: boolean;
  onSelect: () => void;
}

export function TimelineLane({ track, title, duration, selected, onSelect }: Props) {
  const d = Math.max(0.01, duration);
  return (
    <button
      onClick={onSelect}
      className={`relative h-9 w-full overflow-hidden rounded-md border px-2 pt-1 text-left transition-colors ${
        selected
          ? "border-ed-accent bg-ed-active"
          : "border-ed-border bg-ed-panel-2 hover:border-ed-line"
      }`}
    >
      <span className="block truncate text-[11px] font-medium text-ed-text">{title}</span>
      <div className="pointer-events-none absolute inset-x-2 bottom-1.5 h-1.5 rounded-full bg-ed-border">
        {track.keyframes.map((k, i) => {
          const left = `${Math.min(100, Math.max(0, (k.time / d) * 100))}%`;
          return (
            <span
              key={`${track.id}-${i}`}
              className="absolute top-1/2 h-2.5 w-2.5 -translate-x-1/2 -translate-y-1/2 rounded-full border border-white bg-ed-accent shadow-sm"
              style={{ left }}
            />
          );
        })}
      </div>
    </button>
  );
}
